import React, { useEffect, useState } from "react";
import { ListingWrapper } from "./putAwayItems.style";
import PutAwayTable from "../components/PutAwayTable/PutAwayTable";
import UserGreeting from "../../../components/UserGreeting/UserGreeting";
import { Result, message, Tabs } from "antd";
import {
  fetchBatchPutAwayDetails,
  rackItemsToBinPutaway,
} from "../service/putAwayServices";
import { connect } from "react-redux";
import { SOMETHING_WENT_WRONG, warehouseId } from "../../../constants";
import TMLoader from "../../../components/Loader/Loader";
import { handleError } from "../../../redux/makeApiCall";
import { TOBPBack } from "../../TOBinTransfer/TOBinPicker/TOBPMed/TOBPMed.style";
import { IoArrowBackCircle } from "react-icons/io5";
import { Base64func } from "../../../components/Base64Func/Base64func";
import PutAwayModal from "../components/PutAwayModal/PutAwayModal";

const PutAwayItems = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [{ headerInfo, pickedData }, setPutAwayDetails] = useState({});
  let { vendorId, billNumber } = props.match.params;
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState({});
  const [allRacked, setAllRacked] = useState(false);

  vendorId = Base64func(vendorId, "decode");
  billNumber = Base64func(billNumber, "decode");

  const getRecords = async () => {
    setIsLoading(true);

    try {
      const response = await fetchBatchPutAwayDetails({
        vendorId: vendorId,
        billNumber: billNumber,
        warehouseId,
        access_token: props.access_token,
      });
      if (response?.data?.statusCode === 200) {
        if (response.data?.responseData?.headerInfo?.allRacked) {
          setAllRacked(true);
        }
        setPutAwayDetails(response.data?.responseData || []);
        setIsLoading(false);
      } else if (response.data.statusCode === 204) {
        setIsLoading(false);
        message.error(response.data.message || SOMETHING_WENT_WRONG, 2);
        setTimeout(() => {
          props.history.push("/put-away-invoices");
        }, 2000);
      } else {
        throw new Error(response?.data?.message || SOMETHING_WENT_WRONG);
      }
    } catch (error) {
      const err = handleError(error);
      message.error(err || SOMETHING_WENT_WRONG);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getRecords();
  }, []);
  const columns = [
    {
      title: "Product Name",
      dataIndex: "productName",
      key: "productName",
      align: "center",
      filter: true,
    },
    {
      title: "Batch Number",
      dataIndex: "batchNumber",
      key: "batchNumber",
      align: "center",
    },
    {
      title: "Pending Quantity",
      dataIndex: "pendingQuantity",
      key: "pendingQuantity",
      align: "center",
    },
    {
      title: "Total Quantity",
      dataIndex: "totalQuantity",
      key: "totalQuantity",
      align: "center",
    },
  ];
  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      const params = {
        access_token: props.access_token,
        data: { ...data, billNumber, vendorId: Number(vendorId) },
        warehouseId,
      };
      const response = await rackItemsToBinPutaway(params);
      if (response.data.statusCode === 200) {
        message.success(response.data.message || "Item racked !");
        if (response.data?.responseData?.isFullyRacked) {
          setAllRacked(true);
          setModalIsOpen(false);
          setIsLoading(false);
        } else {
          setModalIsOpen(false);
          getRecords();
        }
      } else {
        throw new Error(response.data.message || SOMETHING_WENT_WRONG);
      }
    } catch (error) {
      const err = handleError(error);
      message.error(err || SOMETHING_WENT_WRONG);
      setIsLoading(false);
    }
  };
  return (
    <ListingWrapper className="centerScreen">
      {isLoading && <TMLoader />}
      <TOBPBack onClick={() => props.history.push("/put-away-invoices")}>
        <IoArrowBackCircle /> Back
      </TOBPBack>
      <div className="headerWrapper">
        <UserGreeting />
      </div>
      <div className="headerInfo">
        <div className="infoWrapper">
          <div className="infoLabel">Vendor Name :</div>
          <div className="infoValue">{headerInfo?.vendorName}</div>
        </div>
        <div className="infoWrapper">
          <div className="infoLabel">Bill Number :</div>
          <div className="infoValue">{billNumber}</div>
        </div>
      </div>
      {allRacked ? (
        <Result
          status="success"
          title="All Items Racked"
          extra={
            <button
              className="bbtn"
              // disabled={isLoading}
              onClick={() => props.history.push("/put-away-invoices")}
            >
              Go to home
            </button>
          }
        />
      ) : (
        <Tabs
          defaultActiveKey="1"
          items={[
            {
              label: `Not Racked`,
              key: "1",
              children: (
                <PutAwayTable
                  columns={columns}
                  dataSource={
                    pickedData?.filter((item) => item.racked === false) || []
                  }
                  onRowClick={(record) => {
                    if (record.racked) {
                      message.error("Already Racked !");
                      return;
                    }
                    setModalIsOpen(true);
                    setSelectedRecord(record);
                  }}
                />
              ),
            },
            {
              label: `Racked`,
              key: "2",
              children: (
                <PutAwayTable
                  columns={columns}
                  dataSource={
                    pickedData?.filter((item) => item.racked === true) || []
                  }
                  onRowClick={(record) => {
                    if (record.racked) {
                      message.error("Already Racked !");
                      return;
                    }
                    setModalIsOpen(true);
                    setSelectedRecord(record);
                  }}
                />
              ),
            },
          ]}
        />
      )}
      {modalIsOpen && (
        <PutAwayModal
          record={selectedRecord}
          onSubmit={onSubmit}
          access_token={props.access_token}
          onCancel={() => {
            setModalIsOpen(false);
            getRecords();
          }}
        />
      )}
    </ListingWrapper>
  );
};

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
  isOnline: state.statusReducer?.isOnline,
  TOReducer: state.TOReducer,
});

export default connect(mapStateToProps, {})(PutAwayItems);
